<!-- <div class="marquee-container" #container *ngIf="message"> -->
<div class="marquee-container" #container [hidden]="!message" style="position: absolute;">
      <div 
        class="marquee-content" 
        #content
        [style.animation-duration]="animationDuration + 's'"
        [style.animation-play-state]="isPaused ? 'paused' : 'running'"
      >
        {{ message }}
      </div>
      <div class="marquee-controls">
        <button (click)="togglePause()" class="control-btn">
          {{ isPaused ? '▶️' : '⏸️' }}
        </button>
        <button (click)="adjustSpeed('slower')" class="control-btn">🐌</button>
        <button (click)="adjustSpeed('faster')" class="control-btn">🐰</button>
        <button (click)="refreshMessages()" class="control-btn">🔄</button>
      </div>
    </div>
    @if(!message && !isLoading){
    <div class="no-messages" *ngIf="!message && !isLoading">
      No broadcast messages available
    </div>
    }
    @if(isLoading){
    <div class="loading" *ngIf="isLoading">
      Loading messages...
    </div>
    }

